import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("eradik-cookie-consent")) {
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const accept = () => {
        localStorage.setItem("eradik-cookie-consent", "accepted");
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    data-testid="cookie-banner"
                    initial={{ y: 60, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 60, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 200, damping: 22 }}
                    className="fixed bottom-6 left-5 right-5 z-50 max-w-md rounded-3xl border border-black/10 bg-white p-6 shadow-[0_20px_60px_rgba(10,15,36,0.2)] sm:left-6 sm:right-auto"
                    role="dialog"
                    aria-label="Information sur les cookies"
                >
                    <button
                        data-testid="cookie-close-button"
                        onClick={accept}
                        className="absolute right-4 top-4 text-slate-400 transition-colors hover:text-night"
                        aria-label="Fermer"
                    >
                        <X className="h-4 w-4" />
                    </button>
                    <div className="flex items-start gap-4">
                        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-brand/10 text-brand">
                            <Cookie className="h-5 w-5" />
                        </div>
                        <div>
                            <p className="font-display font-bold text-night">Respect de votre vie privée</p>
                            <p className="mt-1.5 text-xs leading-relaxed text-slate-600">
                                Ce site n'utilise que des cookies strictement nécessaires à son fonctionnement.
                                Aucun cookie publicitaire ou de suivi n'est déposé.{" "}
                                <Link to="/politique-confidentialite" className="font-semibold text-brand underline">
                                    En savoir plus
                                </Link>
                            </p>
                            <button
                                data-testid="cookie-accept-button"
                                onClick={accept}
                                className="mt-4 rounded-full bg-brand px-6 py-2.5 text-sm font-bold text-white transition-[background-color,transform] duration-300 hover:bg-brand-hover hover:scale-105 active:scale-95"
                            >
                                J'ai compris
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieBanner;
